// extracted by mini-css-extract-plugin
export default {"hamburger":"SOIoya","hamburger-inner":"e90fX4","hamburgerInner":"e90fX4","hideOnMobile":"NiqGVr","leftButton":"WsOW8Y","hamburger-box":"DlihOv","hamburgerBox":"DlihOv"};